import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import AISuggestionEditing from './aisuggestionediting';
import AISuggestionUI from './aisuggestionui';

export default class AISuggestion extends Plugin {
  static get requires() {
    return [AISuggestionEditing, AISuggestionUI];
  }

  init() {
    console.log('AISuggestion was initialized', this.editor);
  }
}